import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom/cjs/react-router-dom.min";
import App from "./App";
import PopupContextProvider from "./contexts/PopupContext";
import SnackbarContextProvider from "./contexts/SnackbarContext";
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import './react-range-datepicker-overrides.css';
import "./i18n";


import UserContextProvider from "./contexts/UserContextProvider";

const rootElement = document.getElementById("root");

ReactDOM.render(
    <BrowserRouter>
        <SnackbarContextProvider>
            <PopupContextProvider>
                <UserContextProvider>
                    <App />
                </UserContextProvider>
            </PopupContextProvider>
        </SnackbarContextProvider>
    </BrowserRouter>,
    rootElement
);
